// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__24ueW","footer":"ModalUpdate_footer__5mlF2"};